// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"N4-z","dimensionLabel":"O4-z","styleChooserControlWrapper":"P4-z","styleChooserControl":"Q4-z","disabled":"R4-z","giftCard":"S4-z","styleChooserText":"T4-z"};